module.exports = __webpack_public_path__ + "img/ellipse-texture.83f95489.svg";